import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/货种左.png'
import _imports_1 from '@/assets/images/货种右.png'


const _hoisted_1 = { class: "cargo-flight" }
const _hoisted_2 = { class: "cargo-layer2" }
const _hoisted_3 = { class: "cargo-layer3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "cargo-layer3-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "货种")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)

export function render(_ctx, _cache) {
  const _component_StationRouter = _resolveComponent("StationRouter")
  const _component_MiniTitle = _resolveComponent("MiniTitle")
  const _component_Left = _resolveComponent("Left")
  const _component_Right = _resolveComponent("Right")
  const _component_item = _resolveComponent("item")

  return (_openBlock(), _createBlock(_component_item, { title: "国际货运航班" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_StationRouter, { value: _ctx.data }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_MiniTitle, {
            title: "去程货种",
            style: {"width":"400px"}
          }),
          _createVNode(_component_MiniTitle, {
            title: "回程货种",
            style: {"width":"345px"}
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Left, { data: _ctx.leftData }, null, 8, ["data"]),
          _hoisted_4,
          _createVNode(_component_Right, { data: _ctx.rightData }, null, 8, ["data"])
        ])
      ])
    ]),
    _: 1
  }))
}